// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"closeIcon-te75K"};